export const CONSULTANTS = 1
export const STAFF = 2
